<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit.prevent="submit" validated novalidate>
                  <ValidationObserver ref="observer">
                    <h1>로그인</h1>
                    <p class="text-muted">계정에 로그인할 수 있습니다</p>

                    <ValidationProvider
                      v-slot="{ errors }"
                      name="username"
                      rules="required|min:1|max:100"
                    >
                      <CInput
                        placeholder="아이디"
                        autocomplete="username email"
                        v-model="form.username"
                        :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                        :is-valid="errors.length > 0 ? false : null"
                      >
                        <template #prepend-content>
                          <CIcon name="cil-user" />
                        </template>
                      </CInput>
                    </ValidationProvider>

                    <ValidationProvider
                      v-slot="{ errors }"
                      name="password"
                      rules="required|min:4|max:20"
                    >
                      <CInput
                        placeholder="비밀번호"
                        type="password"
                        autocomplete="curent-password"
                        v-model="form.password"
                        :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                        :is-valid="errors.length > 0 ? false : null"
                      >
                        <template #prepend-content>
                          <CIcon name="cil-lock-locked" />
                        </template>
                      </CInput>
                    </ValidationProvider>
                    <CInputCheckbox
                      label="로그인 상태 유지"
                      :checked.sync="form.rememberMe"
                      class="mb-3"
                    />
                    <CRow>
                      <CCol col="6" class="text-left">
                        <CButton type="submit" color="primary" class="px-4"
                        >로그인
                        </CButton>
                      </CCol>
                      <CCol col="6" class="text-right">
                        <!--                      <CButton color="link" class="px-0">Forgot password?</CButton>-->
                        <CButton color="link" class="d-lg-none" to="/register"
                        >회원가입
                        </CButton>
                      </CCol>
                    </CRow>
                  </ValidationObserver>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>회원가입</h2>
                <p>사이트를 이용하려면 <br />회원으로 등록해야합니다.</p>
                <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                  to="/register"
                >
                  지금 가입하기
                </CButton>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import { max, min, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import core from "@/core";

extend("required", required);
extend("min", min);
extend("max", max);

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    username: "아이디",
    password: "비밀번호",
  },
});

export default {
  name: "Login",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        rememberMe: true,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      core.loader.hide();
    });
  },
  methods: {
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        const params = core.utils.deepCopy(this.form);
        try {
          const user = await this.$store.dispatch("auth/login", params);
          await this.$store.dispatch("getFacilityList", true);
          await this.$router.push("/");
        } catch (e) {
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
        core.loader.hide();
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
